/**
 * Shared CWInput labels for Stripe keys (title bold, note in regular weight).
 * NBSP after "start with:" so the gap stays visible (plain spaces can collapse next to inline bold).
 */
export const stripeSecretKeyCwInputLabel = (
  <>
    <span className="f-bold">Stripe Secret Key</span>
    {'. Please note: The pasted text should start with:'}
    {'\u00a0'}{'\u00a0'}
    <span className="f-bold">sk_live</span>
    {' (NOT: '}{'\u00a0'}{'\u00a0'}{'sk_test).'}
  </>
);

export const STRIPE_SECRET_KEY_LIVE_ERROR =
  'The pasted text should start with:  sk_live (NOT:   sk_test).*';

export const hasInvalidStripeSecretKey = (value?: string | null) => {
  const environment = (process.env.REACT_APP_ENV || '').trim().toLowerCase();
  if (environment !== 'prod' && environment !== 'production') {
    return false;
  }
  const key = (value ?? '').trim();
  return key !== '' && !key.startsWith('sk_live');
};

export const stripePublicKeyCwInputLabel = (
  <>
    <span className="f-bold">Stripe Public Key</span>
    {'. Please note: The pasted text should start with:'}
    {'\u00a0'}{'\u00a0'}
    <span className="f-bold">pk_live</span>
    {' (NOT: '}{'\u00a0'}{'\u00a0'}{'pk_test).'}
  </>
);
